import { Url } from 'url';
import _ from 'lodash';

const w: any = window;

interface IEnvironment {
   version: string,
   macroServiceUrl: Url,
   environment: string;
}

let environment: IEnvironment = {
   version: '1.0',
   macroServiceUrl: w?._env_?.MACRO_SERVICE_URL,
   environment: w?._env_?.ENVIRONMENT
};

//console.log('Loc 221015-1022: Environment:', environment);

const newLocal: any = 'runConfig';
const runConfig = window[newLocal]; // Environment base runtime configuration

environment = _.merge(environment, runConfig);

export default environment;
